export const isGroupAndRandomiseGroup = (groups, flowId) => {
  if (!groups || !groups.length || !flowId) {
    return false;
  }

  const group = groups.find(g => g.id === flowId);

  return !!(group && group.isGroupAndRandomise);
};

export const getParentGroupOfFlow = (groups, flowId) => {
  if (!groups || !groups.length || !flowId) {
    return null;
  }

  return groups.find(g => g.flows && g.flows.indexOf(flowId) > -1) || null;
};

/*
Checks if a group is a part of a Group & Randomise structure, which means the
group itself is the Group & Randomise parent group or one of its child groups.
Groups holding a Group & Randomise block (distributor groups for example) are
not a part of it.
*/
export const isInsideGroupAndRandomise = (groups, groupId) => {
  if (!groups || !groups.length || !groupId) {
    return false;
  }

  let currentGroup = groups.find(g => g.id === groupId);
  const visitedGroupIds = [];

  while (currentGroup && visitedGroupIds.indexOf(currentGroup.id) === -1) {
    if (currentGroup.isGroupAndRandomise) {
      return true;
    }

    visitedGroupIds.push(currentGroup.id);
    currentGroup = getParentGroupOfFlow(groups, currentGroup.id);
  }

  return false;
};
